<script>
import Ajouter from "../../components/PageForm"
import Section from "../../components/PageSection"
// import PhaseLine from "../../components/projets/Contrat/phaseLine"
import Modale from "../../components/Modale"
import ModalYesNo from "../../components/ModalYesNo"
import Spinner from "../../components/Spinner"

import {updateMontant} from '../../mixins/updateMontant.js';
import {allAboutDates} from '../../mixins/allAboutDates.js';
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapMutations, mapGetters, mapActions } = createNamespacedHelpers('projet')

export default {
  name: 'menu1',
  components: {
    Ajouter,
    Section,
    // PhaseLine,
    Modale,
    ModalYesNo,
    Spinner,
  },
  computed: {
    ...mapState({
      travauxHT: 'travauxHT',
    }),
    ...mapGetters({

    }),
  },
  mixins:[
    updateMontant,
    allAboutDates,
  ],
  data(){
    return{
      projet: null,
      phaseAjoutee: "",                 // La phase sélectionnée dans la formulaire
      phases: [],                       // Toutes les phases du projet affiché
      fullyLoaded: false,              // Un flag pour savoir quand les phases sont chargées par mounted
      phaseLabels: null,                // Tous les labels de cette agence
      contrats: [],
      contractualises: [],
      activeContrat: 0,                 //la colonne affichée pour les avenants : par défaut 0, le contrat initial
      isModaleVisible: false,
      isModaleDeleteVisible: false,
      isModaleContratVisible: false,
      isModaleDelContratVisible: false,
      isModaleSpecificVisible: false,
      isSpecific: true, //Pour la modale de création de phase : est-ce que la phase créée est spécifique à ce projet. Par défaut oui.
      modaleInfos: {
        type:"",
      },
      // fullMontants: [],
    }
  },
  async mounted(){
    //Chargement du projet
    const promiseProjet = this.$axios.get('projets/' + this.$route.params._id)
    .then(response => {this.projet = response.data});

    //Chargement des noms de phase pour les listes déroulantes
    const promisePhases = this.$axios.get('phaseLabels/getAllUnflagged/' + this.$store.state.auth.currentAgence._id)
    .then(response => {this.phaseLabels = response.data});

    //Chargement des phases du projet 
    const promisePhasesProjet = this.$axios.get('phases/getByProjet/' + this.$route.params._id + '/' + this.$store.state.auth.currentAgence._id)
    .then(response => {
      this.phases = response.data
    });

    //Chargement des contrats du projet 
    const promiseContrats = this.$axios.get('contrats/getByProjet/' + this.$route.params._id)
    .then(response => {
      if (response.data.length === 0 ){ //Aucun contrat associé au projet (par exemple s'il a été implémenté avant la maj ajoutant le notion de contrat)
        this.alert("Aucun contrat associé au projet", 404)
        console.log("aucun contrat associé au projet !!")
      } else {
        response.data.forEach(e => {
          e.montant = 0; //pour qu'il soit réactif en local
        })

        this.contrats = response.data
      }
    })
    .catch(err => {console.log(err)});

    await Promise.all([promiseProjet, promisePhases, promisePhasesProjet, promiseContrats])
    
    //Chargement des contractualises
    await this.$axios.get('contractualise/getByProjet/' + this.projet._id)
    .then(response => {
      this.contractualises = response.data
    })
    .catch(err => console.log(err))

    //Tout est enfin prêt à être affiché !
    this.fullyLoaded = true;
    //Ajustement du nombre de colonnes dans le grid (après l'affichage)
    this.waitForElm('.sectionPhases__phases__line').then(() => {
        this.setColumns(this.contrats.length, this.activeContrat)
    });


  },
  watch: {
    // Dans les modales, quand on modifie les champs, on enlève l'affichage "erreur"
    modaleInfos: {
      handler: function (newVal) { //(newVal, oldVal)
        if (newVal){
          if(document.getElementById("modale__addSpecific__name")){document.getElementById("modale__addSpecific__name").classList.remove("modale__addSpecific__container__input__error")}
          if(document.getElementById("modale__addSpecific__select")){document.getElementById("modale__addSpecific__select").classList.remove("modale__addSpecific__container__input__error")}
        }
      }, deep: true
    },
  },

  methods: {
    ...mapMutations([
      'setHonoHT',
    ]),
    ...mapActions([

    ]),

    add() {
      if(this.$store.state.auth.currentAgence._id && this.phaseAjoutee=="addSpecificPhase"){
        this.showModale('create')
        //Remettre la liste déroulante à zéro après avoir affiché la modale
        this.phaseAjoutee = ""
      }
      else if (this.$store.state.auth.currentAgence._id && this.phaseAjoutee!=""){

        //Création de la phase
        let phase = {
          agenceId:     this.$store.state.auth.currentAgence._id,
          phaseLabelId: this.phaseAjoutee._id,        
          projetId:     this.projet._id,                            // Le formulaire n'apparait pas si "projet" est vierge, donc il y a forcément un this.projet
          type:         this.phaseAjoutee.type,                     // 0:Études  1:Chantier  2:Mission complémentaire
        };
        
        this.$axios.post('phases/register', phase)
          .then(response => {
              console.log(response.data.message);
              //J'ajoute l'Id reçu de serveur à mon objet Phase en local pour l'ajouter à mon client et pouvoir la manipuler
              phase._id = response.data.phaseId;
              this.phaseAjoutee = "";

              //Ajout d'un attribut name pour le composant enfant (la ligne nom - montants par contrats - total)
              phase.name = this.phaseLabels.find(x => x._id == phase.phaseLabelId).name

              this.phases.push(phase);
              this.phases.sort((a,b) => (a.rank > b.rank) ? 1 : ((b.rank > a.rank) ? -1 : 0));
            })
            .catch(e => {
              console.log(e);
            });
      } else {
        console.log("Pas d'ID d'agence en local (impossible de savoir à quelle ID relier ces nouvelles données) ou pas de valeur dans 'phaseAjoutée'.")
      }
    },

    phasesLabelsBy(i){
      let phases = [];

      this.phaseLabels.forEach(e => {
        if (e.type == i){  // Est-ce que le label correspond au type de phase que je souhaite renvoyer ?
          if (!this.phases.find(x => x.phaseLabelId == e._id)){ //Vérfifier que ce label n'est pas déjà utilisée par les phases existantes
            phases.push(e);
          }
        }
      });

      return phases
    },

    phasesBy(i){
      let phases = [];

      this.phases.forEach(e => {
        if (e.type == i){
          phases.push(e);
        }
      });

      return phases
    },

    phaseToPhase(oldPhaseId, newPhaseId, isDeleted){
      if (newPhaseId != "" && newPhaseId != oldPhaseId){
        this.$axios.put('phases/putToAnotherPhase/' + oldPhaseId + '/' + newPhaseId)
        .then(res => {
          console.log(res.data.message)
          if(isDeleted){
            this.deletePhase(oldPhaseId)
          } else {
            this.isModaleDeleteVisible = false;
          }
        })
        .catch(e => console.log(e))
      }
    },

    deletePhase(_id){
      this.$axios.delete('phases/' + _id + '/' + this.$store.state.auth.currentAgence._id)
        .then(response => {
            this.isModaleDeleteVisible = false;
            console.log(response.data.message);
            
            //Si suppression ok sur le server, suppression sur le client.
            const index = this.phases.findIndex(e => e._id === _id);
            if( index >= 0 ){
                this.phases.splice(index, 1);
            } else {
                console.log("_id non reconnue sur le client, mais suppression effective sur le server.");
            }
        })
        .catch(err => {
            console.log(err)
        });
    },

    //Récupérer le montant d'un contractualise (pour chaque avenant ou contrat de chaque phase, c'est quoi le contenu de l'input ?)
    montantContractualise(phase, contrat){
      let data = this.contractualises.find(e => (e.phaseId == phase._id && e.contratId == contrat._id))
      //Vérifier l'unicité du résultat ?
      if (data){
        let payload = {
          _id : data._id,
          montant: data.montant,
        }

        return payload
      }
    },

    //Mettre à jour le montant des honoraires d'une phase pour un contrat
    async changeMontant(phaseId, contratId, contractualiseId, evt){
      //Si la valeur est bien un nombre (vérification des erreurs de saisie)
      if (this.updateMontant(evt.target.value)){
        //Supprimer l'affichage en rouge s'il y avait une erreur précédemment
        evt.target.classList.remove("sectionPhases__phases__line__error");

        let contractualise = {
          agenceId    : this.$store.state.auth.currentAgence._id,
          projetId    : this.$store.state.projet._id,
          contratId   : contratId,
          phaseId     : phaseId,
          montant     : this.updateMontant(evt.target.value).num,
        }

        // //Est-ce qu'il y avait un valeur précédente que l'on modifie ? Que l'on supprime ? Ou bien est-ce que l'on en crée une nouvelle ?
        if (contractualiseId){
          //Il y avait une valeur avant : on la remplace ou on la supprime ?
          if (this.updateMontant(evt.target.value).num == 0){
            //On supprime
            await this.$axios.delete('contractualise/'+ contractualiseId)
            .then(res => {
              this.alert(res)
              //Suppression du client
              let i
              for (let [index, element] of this.contractualises.entries()){
                if (element._id == contractualiseId){
                  i = index
                }
              }
              this.contractualises.splice(i, 1)
            })
            .catch(err => this.alert(err))
          } else {
            //On modifie
            await this.$axios.put('contractualise/'+ contractualiseId, contractualise)
            .then(res => {
              this.alert(res)
              evt.target.value = this.updateMontant(contractualise.montant).str
              this.contractualises.find(e => (e._id == contractualiseId)).montant = contractualise.montant
            })
            .catch(err => this.alert(err))
          }
        } else if (this.updateMontant(evt.target.value).num != 0){
          //On ajoute
          await this.$axios.post('contractualise/register', contractualise)
          .then(res =>{
            this.alert(res.data.message);
            evt.target.value = this.updateMontant(contractualise.montant).str
            //J'ajoute l'id à l'objet, l'objet au client, pour pouvoir le modifier immédiatement
            contractualise._id = res.data.contractualiseId
            this.contractualises.push(contractualise)
            })
          .catch(err => this.alert(err))
        }

        // this.phaseUpdated(phaseId)

      } else {
        //Surligner l'erreur en rouge dans l'affichage client  
        evt.target.classList.add("sectionPhases__phases__line__error");
      }
    },

    // Ajuster le CSS pour qu'il y ait le bon nombre de colonnes
    setColumns(max, active){
      this.activeContrat = active

      let grids = document.getElementsByClassName("sectionPhases__phases__line") //si changement de nom de classe : à modifier aussi à la fin de mounted
      for (const grid of grids) {
        // let array = ["1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr", "1fr 1fr 1fr 0fr 1fr 4fr 1fr 3fr 1fr 1fr"]
        // grid.style.gridTemplateColumns = array[Math.floor(Math.random() * array.length)];

        // Générer la string pour le grid-template
        // Pour que l'animation suive, il faut garder le même nombre de colonnes que celles décalrées dans le CSS d'origine (26), et il ne faut pas utiliser la fonction "repeat( i, jpx)"
        
        // Initialisation de la string avec la colonne des noms de phases
        let str = "1fr "
        
        //J'ajoute des colonnes vides et sans épaisseur pour compléter et arriver à 26 colonnes au total
        for (let i = 1; i < (26 - max - 3); i++) {
          str += "0fr "
        }

        //J'ajoute les colonnes de 15px de large avec le point affiché pour les contrats avant le contrat actif
        for (let i = 0; i < active; i++) {
          str += "15px "
        }

        //J'ajoute une colonne de 80px de large pour le contrat actif
        str += "80px "

        //J'ajoute les colonnes de 15px de large avec le point affiché pour les contrats après le contrat actif
        for (let i = 0; i < (max - active - 1); i++) {
          str += "15px "
        }

        // Je termine ma string avec la colone du total et de la poubelle
        str +="80px 30px"

        grid.style.gridTemplateColumns = str
      //   if (active == 0){
      //     console.log(1)
          // grid.style.gridTemplateColumns = "1fr repeat("+ (23 - max) +", 0fr) 80px repeat(" + (max - 1) + ", 15px) 80px 30px" //(3 + max ) colonnes : il en manque (23-max)
      //  // grid.style.gridTemplateColumns = "1fr 80px repeat(" + (max - 1) + ", 15px) 80px 30px" //(3 + max ) colonnes : il en manque (23-max)
      //   } else if (active == (max -1)){
      //     console.log(2)
      //     grid.style.gridTemplateColumns = "1fr repeat("+ (22 - active) +", 0fr) repeat(" + (active) + ", 15px) 80px 80px 30px" //(4+active) : il en manque 22-active
      //  // grid.style.gridTemplateColumns = "1fr repeat(" + (active) + ", 15px) 80px 80px 30px" //(4+active) : il en manque 22-active
      //   } else {
      //     console.log(3)
      //     grid.style.gridTemplateColumns = "1fr repeat("+ (23 - max) +", 0fr) repeat(" + (active) + ", 15px) 80px repeat(" + (max - active - 1) + ", 15px) 80px 30px" //(3 + max ) colonnes : il en manque (23-max)
      //  // grid.style.gridTemplateColumns = "1fr repeat(" + (active) + ", 15px) 80px repeat(" + (max - active - 1) + ", 15px) 80px 30px" //(3 + max ) colonnes : il en manque (23-max)
      //   }

      }
    },

    //Attendre qu'un élément existe dans le DOM
    waitForElm(selector) {
      return new Promise(resolve => {
          if (document.querySelector(selector)) {
              return resolve(document.querySelector(selector));
          }

          const observer = new MutationObserver(() => {
              if (document.querySelector(selector)) {
                  observer.disconnect();
                  resolve(document.querySelector(selector));
              }
          });

          observer.observe(document.body, {
              childList: true,
              subtree: true
          });
      });
  },
    
    //Mettre à jour les montants totaux de chaque contrat (et du total par réactivité)
    // phaseUpdated(phase){
    //   //Est-ce que les montants de cette phase existent déjà ou est-ce que j'ajoute ?
    //   if (this.fullMontants.find(elmt => (elmt._id == phase._id))){
    //     //Je détecte quel contrat à changé
    //     let indexContratModif
    //     for (let i = 0 ; i < phase.montants.length; i++){
    //       if (phase.montants[i] !== this.fullMontants.find(elmt => (elmt._id == phase._id)).montants[i]){
    //         indexContratModif = i
    //       }
    //     }

    //     //Je met à jour fullMontant avec la phase updated
    //     let indexPhaseModif = this.fullMontants.findIndex(elmt => (elmt._id == phase._id))
    //     this.fullMontants[indexPhaseModif] = phase

    //     //Je recalcule le montant du contrat
    //     if (!isNaN(indexContratModif)){
    //       this.contrats.forEach((contrat, index) => {
    //         if (index == indexContratModif){
    //           let somme = 0
    //           for (let localPhase of this.fullMontants){
    //             if(localPhase.montants[indexContratModif] != undefined){
    //               somme += localPhase.montants[indexContratModif]
    //             }
    //           }
    //           contrat.montant = somme
    //         }
    //       })
    //     } else {
    //       console.log("Erreur dans la mise à jour du montant du contrat.")
    //     }
    //   } else {
    //     this.fullMontants.push(phase)
    //     this.contrats.forEach((contrat, index) => {
    //       if (isNaN(contrat.montant)){
    //         contrat.montant = this.fullMontants[this.fullMontants.length - 1].montants[index]
    //       } else {
    //         contrat.montant = contrat.montant + this.fullMontants[this.fullMontants.length - 1].montants[index]
    //       }
    //     })
    //   }
    // },


    //Calculer le montant total pour un contrat (avenant ou marché initial)
    totalContrat(contratId){
      let total = 0;
      this.contractualises.forEach(e => {
        if (e.contratId == contratId){
          total +=  e.montant;
        }
      });

      return total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },

    //Le montant total du projet
    montantTotalHT(){
      let total = 0;
      this.contractualises.forEach(e => {
        total +=  e.montant;
      });

      total = total.toFixed(0)

      this.setHonoHT(total);
      let pourcentage
      if (this.travauxHT){
        pourcentage = (total / this.travauxHT * 100).toFixed(2)
      } else {
        pourcentage = "-"
      }
      total = total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

      return {total: total, pourcentage: pourcentage}
    },

    totalPhaseHT(phaseId){
      let myArray = this.contractualises.filter(e => e.phaseId == phaseId)
      let total =  myArray.reduce((acc, e) => acc + e.montant, 0)
      
      return this.updateMontant(total).str + " €"
    },
    
    showModale(name, infos){
      switch (name) {
        case '':{
          this.isModaleVisible = true;
          break;
        }
        case 'delete':{
          this.$axios.get('phases/getAllForOne/' + infos._id)
          .then(res => {
            this.modaleInfos = infos;
            this.modaleInfos.facture = res.data.facture
            this.modaleInfos.heures = res.data.heures
            this.modaleInfos.jours  = res.data.jours
            this.modaleInfos.frais  = res.data.frais
            this.modaleInfos.prestas  = res.data.prestas
            this.modaleInfos.name = this.phases.find(e => e._id == infos._id).name //Ajoute du nom de la phase en cours

            if (this.modaleInfos.heures + this.modaleInfos.jours + this.modaleInfos.frais + this.modaleInfos.prestas == 0){
              this.modaleInfos.deletable = true
            } else {
              this.modaleInfos.deletable = false
            }

            this.isModaleDeleteVisible = true;
          })
          .catch(e => console.log(e))
          break;
        }
        case 'delContrat':{
          this.isModaleDelContratVisible = true;
          this.modaleInfos = infos;
          break;
        }
        case 'contrat':{
          this.isModaleContratVisible = true;
          // this.modaleInfos = infos;
          // Si je suis aussi direct que la ligne du dessus, il y a fusion des deux variables. C'est pratique car dès que je modifie le champ, le client est à jour, mais si finalement je souhaite annuler mes modifications, pas de retrour arrière possible.
          // Je dissocie donc les deux valeurs, ce qui m'oblige à mettre à jour le client après ajout en BDD (voir "putContrat()")
          this.modaleInfos = {...infos}
          break;
        }
        case 'create':{
          this.isModaleSpecificVisible = true;
          this.modaleInfos.type= ""
        }
      }
    },

    closeModale(){
      this.isModaleVisible = false;
      this.isModaleDeleteVisible = false;
      this.isModaleDelContratVisible = false;
      this.isModaleContratVisible = false;
      this.isModaleSpecificVisible = false;
      this.modaleInfos = {
        type:"",
      };
    },

    //Ajouter un avenant au projet
    addContrat(){
      let contrat = {
        agenceId: this.$store.state.auth.currentAgence._id,      
        projetId: this.projet._id,                            
        date: Date.now(),                                         
        name: "Avenant n°" + (this.contrats.length)                                    
      }
      //ajout en bdd
      this.$axios.post('contrats/register', contrat)
      .then(res => {
        console.log(res.data)
        
        //Ajout sur le client 
        contrat.date = res.data.contrat.date
        contrat._id  = res.data.contrat._id
        contrat.montant = 0
        this.contrats.push(contrat)

        //Création d'une colonne supplémentaire
        this.setColumns(this.contrats.length, this.contrats.length - 1)
        })

      .catch(err => console.log(err))
    },

    //Modifier un avenant ou un contrat
    putContrat(){
      let newContrat = {
        date : this.modaleInfos.date,
        name : this.modaleInfos.name
      }

      if (newContrat.date != null){
        this.$axios.put('contrats/'+ this.modaleInfos._id, newContrat)
        .then(res => {
          console.log(res)
          // Je cherche ce contrat sur le client et je le modifie.
          this.contrats.forEach(e => {
            if (e._id == this.modaleInfos._id){
              e.name = newContrat.name;  
              e.date = newContrat.date;
            }
          })
          this.closeModale()
        })
        .catch(err => console.log(err))
      } else {
        this.alert("La date ne peut pas être nulle.")
      }
    },

    //Supprimer un avenant
    delContrat(_id){
      this.$axios.delete('contrats/'+ _id)
      .then(res => {
        console.log(res)

        //Supprimer les montants contractualisés associés à ce contrat
        this.$axios.delete('contractualise/contrat/'+ _id)
        .then(response => {
          console.log(response.data.message)

          //Une fois que la BDD est propre, je modifie les contractualise dans le client.
          this.contractualises = this.contractualises.filter(e => e.contratId != _id)

          //J'enlève le contrat du côté du client
          let index = 0
          for (const e of this.contrats){
            if (e._id == _id){
              break;
            }
            index ++
          }
          this.contrats.splice(index, 1)

          //Puis je mets à jour l'affichage
          this.setColumns(this.contrats.length, 0)

        })
        .catch(err => console.log(err.message))

        this.isModaleDelContratVisible = false;
      })
      .catch(err => console.log(err))
    },

    //Créer une phase, spécifique ou non
    async createPhase(){
      //Vérfication du formulaire : il y a bien un nom et un type
      let formOk = true;
      let rank = 99; //Une variable pour stocker le rang du futur phaseLabel

      if (!this.modaleInfos.name){
        document.getElementById("modale__addSpecific__name").classList.add("modale__addSpecific__container__input__error")
        this.alert("Veuillez vérifier votre saisie")
        formOk = false
      }

      if (this.modaleInfos.type == ""){
        document.getElementById("modale__addSpecific__select").classList.add("modale__addSpecific__container__input__error")
        this.alert("Veuillez vérifier votre saisie")
        formOk = false
      }

      if (formOk){
        let allGood = true

        //Vérifier qu'il y a bien une ID d'agence dans le local store, sinon je ne saurai pas à quelle agence relier cette nouvelle phase.
        if (!this.$store.state.auth.currentAgence._id){
          this.alert("Pas d'ID d'agence, création de phase impossible")
          allGood = false
        }

        //Récupérer le dernier rank actuel pour ajouter la phase à la suite
        await this.$axios.get('phaseLabels/getLastRank/' + this.$store.state.auth.currentAgence._id + '/' + this.modaleInfos.type)
        .then(response => rank = response.data)
        .catch(err => {
          this.alert(err)
          allGood = false
        })
        

        if (allGood) {
          //Création du phase Label
          let newLabel = {
            agenceId: this.$store.state.auth.currentAgence._id,
            name: this.modaleInfos.name,
            type: parseInt(this.modaleInfos.type, 10),
            rank: rank,
            deleted : this.isSpecific //Si ma nouvelle phase est spécifique à ce projet, alors je supprime directement le label.
          }

          await this.$axios.post('phaseLabels/register', newLabel)
          .then(response => {
            this.alert(response)
            //J'ajoute l'Id reçu de serveur à mon objet newLabel en local pour l'ajouter à mon client et pouvoir la manipuler
            newLabel._id = response.data.phaseId;
          })
          .catch(e => {
            this.alert(e);
          });
          
          //Création de l'objet phase
          let newPhase = {
            agenceId: this.$store.state.auth.currentAgence._id,
            phaseLabelId: newLabel._id,
            projetId: this.$route.params._id,
            type : newLabel.type
          }

          //Si la phase est créée comme unique, lui ajouter cette propriété. Cela pourra servir par la suite notamment si je veux pouvoir modifier les noms des phases unique directement depuis la page contrat
          if (this.isSpecific){
            newPhase.unique = true;
          }

          //Ajout de la phase en BDD
          this.$axios.post('phases/register', newPhase)
          .then(response => {
            this.alert(response)
            //J'ajoute l'Id reçu de serveur à mon objet Phase en local pour l'ajouter à mon client et pouvoir la manipuler
            newPhase._id = response.data.phaseId;

            //Ajout d'un attribut name pour le composant enfant (la ligne nom - montants par contrats - total)
            newPhase.name = newLabel.name

            this.phases.push(newPhase);
            this.closeModale();
          })
          .catch(e => this.alert(e))
        }
      }
    }
  },
}
</script>


<template>
    <div v-if="!fullyLoaded">
      <Spinner/>
    </div>
    <div v-else class="contratMain">

      <!-- Suppression de phase -->
      <Modale v-if="isModaleDeleteVisible" @close="closeModale">
        <template v-slot:header>
            <span>Supprimer la phase</span>
        </template>
        <template v-slot:body v-if="modaleInfos.facture">
            <p>La phase <b>{{modaleInfos.name}}</b> a déjà été en partie facturée. Vous ne pouvez pas supprimer une phase déjà facturée.</p>
        </template>
        <template v-slot:body v-else-if="modaleInfos.deletable">
            <p>Vous êtes sur le point de supprimer la phase <b>{{modaleInfos.name}}</b>. Êtes vous sûr ?</p>
        </template>
        <template v-slot:body v-else>
            <p>La phase <b>{{modaleInfos.name}}</b> contient :
              <ul>
                <li v-if="modaleInfos.jours   !=0">{{modaleInfos.jours}} jours</li>
                <li v-if="modaleInfos.heures  !=0">{{modaleInfos.heures}} heures</li>
                <li v-if="modaleInfos.frais   !=0">{{modaleInfos.frais}} € de note de frais</li>
                <li v-if="modaleInfos.prestas !=0">{{modaleInfos.prestas}} € de prestations extérieures</li>
              </ul>
            </p>
            <p>Vous ne pouvez pas supprimer cette phase tant que des éléments lui sont affectés. Veuiller les affecter à une autre phase de ce projet avant suppression. Cette action est irréversible.</p>
            <div class="modale__deletePhase__inputBox">
              <div><input type="checkbox" id="nouvellePhase" name="nouvellePhase" checked disabled>
                <label for="nouvellePhase">Affecter les éléments à la phase :
                  <select name="phases" id="phase-select" @change="modaleInfos.newPhaseId = $event.target.value">
                    <option value="">-- Choisir une phase --</option>
                    <option v-for="phase in phases" :key="phase._id" :value="phase._id"> {{phase.name}} </option>
                  </select>
                </label>
              </div>
              <div><input type="checkbox" id="nouvellePhase" name="nouvellePhase" @change="modaleInfos.delete = $event.target.value"><label for="nouvellePhase">Et supprimer la phase <b>{{modaleInfos.name}}</b></label></div>
            </div>
        </template>
        <template v-slot:footer v-if="modaleInfos.facture">
        </template>
        <template v-slot:footer v-else-if="modaleInfos.deletable">
            <ModalYesNo @no="closeModale" @yes="deletePhase(modaleInfos._id)"></ModalYesNo>
        </template>
        <template v-slot:footer v-else>
            <ModalYesNo @no="closeModale" @yes="phaseToPhase(modaleInfos._id, modaleInfos.newPhaseId, modaleInfos.delete)"></ModalYesNo>
        </template>
      </Modale>

      <!-- Création de phase spécifique -->
      <Modale v-if="isModaleSpecificVisible" @close="closeModale">
        <template v-slot:header>
            <span>Créer une nouvelle phase</span>
        </template>
        <template v-slot:body>
            <p>A partir de cette fenêtre, vous pouvez créer une nouvelle phase. Celle-ci peut être soit spécifique à ce projet, soit être ajoutée aux phases par défaut.</p>
            <div class="modale__addSpecific__container">
              <input id="modale__addSpecific__name" type="text" class="modale__addSpecific__container__input" placeholder="Nom de la phase" v-model="modaleInfos.name">
              <select id="modale__addSpecific__select" class="modale__addSpecific__container__input" v-model="modaleInfos.type">
                <option value="">Type de phase</option>
                <option value="hg">----------------------</option>
                <option value="0">Phase d'études</option>
                <option value="1">Phase de chantier</option>
                <option value="2">Mission complémentaire</option>
              </select>
            </div>
            <div class="modale__addSpecific__radioItem">
              <input type="radio" id="specific" value="true" v-model="isSpecific">
              <label for="yes">Créer cette phase uniquement pour ce projet. Elle sera unique et ne sera pas utilisable pour les autres projets.</label>
            </div>
            <div class="modale__addSpecific__radioItem">
              <input type="radio" id="global" value="false" v-model="isSpecific">
              <label for="no">Ajouter également cette phase dans la liste des phases par défaut. Elle pourra alors également être sélectionnable dans les autres projets. La liste des phases par défaut est consultable et modifiable dans les paramètres (<b><router-link to="/params/listes/">"paramètres / listes"</router-link></b>).</label>
            </div>
        </template>
        <template v-slot:footer>
            <ModalYesNo @yes="createPhase" @no="closeModale"></ModalYesNo>
        </template>
      </Modale>
      
      <!-- Suppression de contrat -->
      <Modale v-if="isModaleDelContratVisible" @close="closeModale">
        <template v-slot:header>
            <span>Supprimer le contrat</span>
        </template>
        <template v-slot:body>
            Vous êtes sur le point de supprimer l'{{modaleInfos.name}}. Êtes vous sûr ?
        </template>
        <template v-slot:footer>
            <ModalYesNo @no="closeModale" @yes="delContrat(modaleInfos._id)"></ModalYesNo>
        </template>
      </Modale>

      <!-- Modification de contrat -->
      <Modale v-if="isModaleContratVisible" @close="closeModale">
        <template v-slot:header>
            <span>Modifier le contrat</span>
        </template>
        <template v-slot:body>
          <div class="modale__grid">
            <div>Nom du contrat :</div>
            <input type="text" v-model="modaleInfos.name" class="modale__input">
            <div>Date de signature :</div>
            <input type="date" :value="modaleInfos.date.slice(0, 10) " class="modale__input" @change="modaleInfos.date = $event.target.value">
            <!-- <input type="date" :value="modaleInfos.date.slice(0, 10) " class="modale__input" @change="putContrat(modaleInfos._id, {date: $event.target.value})"> -->
          </div>
        </template>
        <template v-slot:footer>
          <ModalYesNo @yes="putContrat()" @no="closeModale()"></ModalYesNo>
        </template>
      </Modale>

      <!-------------->
      <!--   Col 1  -->
      <!-------------->

      <!-- dans PageProjet.vue -->
      
      <!-------------->
      <!--   Col 2  -->
      <!-------------->
      <Ajouter v-if="projet" class="ajouter" label="Ajouter une phase">
        <template v-slot:body>
          <select v-model="phaseAjoutee" @change="add($event)" class="ajouter__input">
            <option value="addSpecificPhase">Créer une phase spécifique à ce projet</option>
            <option value="">Sélectionner la phase</option>
            <option v-if="phasesLabelsBy(0).length > 0" value="">-------------------------</option>
            <option v-for="phaseLabel in phasesLabelsBy(0)" :key="phaseLabel._id" :value="{type:0, _id:phaseLabel._id}">{{ phaseLabel.name }}</option>
            <option v-if="phasesLabelsBy(1).length > 0" value="">-------------------------</option>
            <option v-for="phaseLabel in phasesLabelsBy(1)" :key="phaseLabel._id" :value="{type:1, _id:phaseLabel._id}">{{ phaseLabel.name }}</option>
            <option v-if="phasesLabelsBy(2).length > 0" value="">-------------------------</option>
            <option v-for="phaseLabel in phasesLabelsBy(2)" :key="phaseLabel._id" :value="{type:2, _id:phaseLabel._id}">{{ phaseLabel.name }}</option>
          </select>
        </template>
      </Ajouter>

      <div class="legende sectionPhases__phases__line"> 
        <div v-for="index in (26 - contrats.length - 3)" :key="index">
          <!-- Des espaces vides pour remplir le grid et aligner à droite les montants, sur une base de 26 colonnes par défaut dans le grid -->
        </div>
        <div v-for="(contrat, index) in contrats" :key="contrat._id" class="legende__label"  @click="setColumns(contrats.length, index)" >
          {{index}}
        </div>
        <div class="legende__label">Total</div>
      </div>

      <!-- Phase d'études -->
      <Section text="Études" class="sectionPhases">
        <template v-slot:body>
          <div v-if="phasesBy(0).length > 0" class="sectionPhases__phases">
            <div v-for="phase in phasesBy(0)" :key="phase._id">
              <div class="sectionPhases__phases__line">
                <span class="sectionPhases__phases__line__name"> {{ phase.name }} </span>
                <div v-for="index in (26 - contrats.length - 4)" :key="index">
                  <!-- Des espaces vides pour remplir le grid et aligner à droite les montants, sur une base de 26 colonnes par défaut dans le grid -->
                </div>
                <div v-for="(contrat, index) in contrats" :key="contrat._id + ':' + phase._id"  class="sectionPhases__phases__line__montant">
                  <div v-if="activeContrat == index">
                    <input v-if="montantContractualise(phase, contrat) != undefined" @change="changeMontant(phase._id, contrat._id, montantContractualise(phase, contrat)._id, $event)" :value="updateMontant(montantContractualise(phase, contrat).montant).str">
                    <input v-else @change="changeMontant(phase._id, contrat._id, undefined, $event)" value="0">
                    <span class="euro">€</span>
                  </div>
                  <div v-else>
                    <span v-if="montantContractualise(phase, contrat) != undefined" class="material-icons" @click="setColumns(contrats.length, index)">circle</span>
                  </div>
                </div>
                <div class="sectionPhases__phases__line__total">{{totalPhaseHT(phase._id)}}</div>
                <span class="material-icons sectionPhases__phases__line__icon" @click="showModale('delete', phase)">delete_outline</span>
              </div>
            </div>
          </div>
          <div v-else class="sectionPhases__noPhase">
            Aucune phase dans cette catégorie.
          </div>
            <!-- <div class="col2__add" @click="add(0)">Ajouter une phase</div> -->
        </template>
      </Section> 
      

      <!-- Phase de chantier -->
      <Section text="Chantier" class="sectionPhases">
        <template v-slot:body>
          <div v-if="phasesBy(1).length > 0" class="sectionPhases__phases">
            <div v-for="phase in phasesBy(1)" :key="phase._id">
              <div class="sectionPhases__phases__line">
                <span class="sectionPhases__phases__line__name"> {{ phase.name }} </span>
                <div v-for="index in (26 - contrats.length - 4)" :key="index">
                  <!-- Des espaces vides pour remplir le grid et aligner à droite les montants, sur une base de 26 colonnes par défaut dans le grid -->
                </div>
                <div v-for="(contrat, index) in contrats" :key="contrat._id + ':' + phase._id"  class="sectionPhases__phases__line__montant">
                  <div v-if="activeContrat == index">
                    <input v-if="montantContractualise(phase, contrat) != undefined" @change="changeMontant(phase._id, contrat._id, montantContractualise(phase, contrat)._id, $event)" :value="updateMontant(montantContractualise(phase, contrat).montant).str">
                    <input v-else @change="changeMontant(phase._id, contrat._id, undefined, $event)" value="0">
                    <span class="euro">€</span>
                  </div>
                  <div v-else>
                    <span v-if="montantContractualise(phase, contrat) != undefined" class="material-icons" @click="setColumns(contrats.length, index)">circle</span>
                  </div>
                </div>
                <div class="sectionPhases__phases__line__total">{{totalPhaseHT(phase._id)}}</div>
                <span class="material-icons sectionPhases__phases__line__icon" @click="showModale('delete', phase)">delete_outline</span>
              </div>
            </div>
          </div>
          <div v-else class="sectionPhases__noPhase">
            Aucune phase dans cette catégorie.
          </div>
        </template>
      </Section>
      

      <!-- Missions complémentaires -->
      <Section text="Misisons complémentaires" class="sectionPhases">
        <template v-slot:body>
          <div v-if="phasesBy(2).length > 0" class="sectionPhases__phases">
            <div v-for="phase in phasesBy(2)" :key="phase._id">
              <div class="sectionPhases__phases__line">
                <span class="sectionPhases__phases__line__name"> {{ phase.name }} </span>
                <div v-for="index in (26 - contrats.length - 4)" :key="index">
                  <!-- Des espaces vides pour remplir le grid et aligner à droite les montants, sur une base de 26 colonnes par défaut dans le grid -->
                </div>
                <div v-for="(contrat, index) in contrats" :key="contrat._id + ':' + phase._id"  class="sectionPhases__phases__line__montant">
                  <div v-if="activeContrat == index">
                    <input v-if="montantContractualise(phase, contrat) != undefined" @change="changeMontant(phase._id, contrat._id, montantContractualise(phase, contrat)._id, $event)" :value="updateMontant(montantContractualise(phase, contrat).montant).str">
                    <input v-else @change="changeMontant(phase._id, contrat._id, undefined, $event)" value="0">
                    <span class="euro">€</span>
                  </div>
                  <div v-else>
                    <span v-if="montantContractualise(phase, contrat) != undefined" class="material-icons" @click="setColumns(contrats.length, index)">circle</span>
                  </div>
                </div>
                <div class="sectionPhases__phases__line__total">{{totalPhaseHT(phase._id)}}</div>
                <span class="material-icons sectionPhases__phases__line__icon" @click="showModale('delete', phase)">delete_outline</span>
              </div>
            </div>
          </div>
          <div v-else class="sectionPhases__noPhase">
            Aucune phase dans cette catégorie.
          </div>
        </template>
      </Section>

      <!-------------->
      <!--   Col 3  -->
      <!-------------->
      <div class="blocInfo">
        <Section text="Total" underlined="true" class="sectionInfos">
          <template v-slot:body>
            <div class="sectionInfos__totalLine">
              <div>Honoraires HT :</div><div> {{montantTotalHT().total}} €</div>
            </div>
            <div class="sectionInfos__totalLine">
              <div>Pourcentage du montant Travaux HT :</div><div> {{montantTotalHT().pourcentage}} %</div>
            </div>
          </template>
        </Section>
        
        <Section text="Historique" underlined="true" class="sectionInfos">
          <template v-slot:body>
            <div class="sectionInfos__line" v-if="contrats.length == 0">Erreur, pas de contrat !</div>
            <div v-else>
              <div v-for="(contrat, index) in contrats" :key="contrat._id" class="sectionInfos__line">
                <div @click="setColumns(contrats.length, index)" class="clickZone"></div> <!-- Juste une zone clicable qui se superpose au reste -->
                <div class="ref"># {{ index }} - {{ dateToNiceStr(contrat.date) }}</div>
                <div class="name"> {{contrat.name}}</div>
                <div class="montant">{{updateMontant(totalContrat(contrat._id)).str}} €</div>  
                <span class="material-icons sectionInfos__line__icon" @click="showModale('contrat', contrat)">create</span>
                <span v-if="index != 0 " class="material-icons sectionInfos__line__icon" @click="showModale('delContrat', contrat)">delete_outline</span>
              </div>
              <div class="sectionInfos__line__add" @click="addContrat" v-if="contrats.length <= 20">
                <span class="material-icons sectionInfos__line__add__icon">add_circle</span>Ajouter un avenant au contrat
              </div>
            </div>
          </template>
        </Section>
      </div>

    </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../assets/main.scss';

.contratMain{
  @include grid-alpha-noFirst;
}

.ajouter{
  grid-column: 1 / 3;

  &__input{
    background-color: $black-lighter;
    border: none;
    width: 200px;
    color: $black-bolder;
  }
}

.legende{
  grid-column: 1 / 3;
  @include monoline;
  display: grid;
  // justify-items: stretch;
  margin: 0px 0 -20px 5px;
  padding: 0 11px; //pour matcher le padding latéral de .sectionPhases__phases + 1px d'épaisseur de bordure 

  & *{
    @include monoline;
  }

  &__label{
    @include myFont;
    font-size: 13px;
    justify-self: flex-end;

    // Tous sauf le dernier
    &:nth-last-child(n + 2){
      justify-self: center;
      cursor: pointer;
      font-weight: bold;

      &:hover{
        color: $color2;
      }
    }
  }
}

.sectionPhases{
  position: relative;
  grid-column: 1 / 3;

  &__phases{
    @include myBlock;
    padding: 10px;

    &__line{
      display: grid;
      grid-template-columns: 1fr 80px repeat(22, 15px) 80px 30px;
      transition: all ease 800ms;

      &__name{
        @include myFont;
        @include monoline;
        font-size: 13px;
        color: $black-bolder;
        grid-column: 1;
      }

      &__montant{
        display: flex;
        justify-content: center;
        border-color: $black;
        border-style: solid;
        border-width: 0 1px 0 0;

        & div{
          display: flex;
          justify-content: center;
          align-items: center;
        }

        & input {
          @include myField;
          color: $main;
          width: 70%;
          text-align: right;
          font-size: 13px;
          padding-right: 10px;
        }
        & .euro{
          @include myFont;
          font-size: 13px;
          color: $main;
          margin-left: -8px;
        }

        & span{
          font-size: 10px;
          color: $main;
        }
        
      }

      &__error{
        color: $alert !important;
        background-color: $alert-lighter;
      }

      &__total{
        @include myFont;
        font-size: 13px;
        color: $black-bolder;
        text-align: right;
        padding: 2px 0 0 0;
      }

      &__icon{
        color: $mainBlack;
        font-size: 20px;
        margin: 0 0 0 10px;

        &:hover{
          cursor: pointer;
          color: $color2;
        }
      }
    }
  }

  &__noPhase{
    @include myFont;
    font-size: 12px;
    color: $black;
  }
}

.blocInfo{
  grid-column: 3;
  grid-row: 1 / span 4;
}

.sectionInfos{
  margin: 0 0 25px 0;

  &__totalLine{
    display: flex;
    justify-content: space-between;
    @include myFont;
    font-size: 13px;
    margin: 5px 0 0 0;
    color: $black-bolder;
  }
  
  &__line{
    display: grid;
    grid-template-columns: auto 1fr repeat(2, 30px);
    @include myFont;
    font-size: 13px;
    margin: 10px 0 0 0;
    color: $black-bolder;

    & .clickZone{
      grid-row: 1 / span 2;
      grid-column: 1 / span 2;
      z-index: 10;
      cursor: pointer;
    }

    & .ref{
      font-size: 11px;
      grid-row: 1;
      grid-column: 1 / span 2;
      color: $black-bold;
    }

    & .name{
      grid-row: 2;
      grid-column: 1;
    }

    & .montant{
      grid-row: 2;
      grid-column: 2;
      justify-self: flex-end;
    }

    &__icon{
      color: $black-bolder;
      font-size: 20px;
      grid-row: 1 / span 2;
      justify-self: flex-end;
      align-self: flex-end;
    }

    &__add{
      @include myFont;
      font-size: 13px;
      margin: 15px 0 0 0;
      color: $black-bolder;
      display: flex;
      align-items: center;

      & > .material-icons{
        color: $main;
        margin: 0 5px 0 0;
      }

      &:hover{
        color: $color2;
        cursor: pointer;

        & .sectionInfos__line__add__icon{
          color: $color2;
        }
      }

      // &:hover .test{
      //   color: $color2;
      // }
    }
  }
}

.modale{
  &__deletePhase{
    &__inputBox{
      margin: 15px 0 0 20px;

      & div{
        display: flex;
        align-items: center;
        margin: 0 0 10px 0;

        & input{
          margin: 0 5px 0 0;
        }

        & select{
            // border-width: 0 0 1px 0;
            color: $black-bolder;
            // border-color: $main;
            // border-width: 1px;
        }
      }
    }
  }

  &__addSpecific{
    &__container{
      display: flex;
      margin: 30px -10px 10px -10px; //gauche-droite : pour compenser le margin des élements enfants

      &__input{
        @include myField;
        flex: 1;
        background-color: white;
        color: $black-bolder;
        margin: 1px 11px 0px 11px; //Les 1px pour compenser la bordure qui apparait en cas d'erreur. Le 10px pour un gap entre les élements. Si je modifie le 10px, le modifier aussi dans la classe .error. LEs 11px, c'est 10 + 1.

        &__error{
          border: $alert 1px solid;
          border-radius: 3px;
          background-color: $alert-lighter;
          margin: 0 10px 0 10px; //Voir .modale__addSpecific__container__input
        }
      }
    }

    &__radioItem{
      margin: 5px 0;
    }
  }

  &__grid{
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-row-gap: 5px
  }

  &__input{
    @include myFont;
  }
}

</style>
